module.exports = __webpack_public_path__ + "img/logo.c3440a7a.png";